import React from "react";


const Hobbies = ()=>{
    return(
        <div className="hobbies">
           <h3>Intérêts</h3>
           <ul>
            <li className="hobby">
                <i className="fa fa-running"></i>
                <span>Course à pied</span>
            </li>
            <li className="hobby">
                <i className="fa fa-draw-polygon"></i>
                <span>Déssin</span>
            </li>
            <li className="hobby">
                <i className="fa fa-seedling"></i>
                <span>Jeux vidéo</span>
            </li>
            <li className="hobby">
                <i className="fa fa-bitcoin"></i>
                <span>Lecture</span>
            </li>
            <li className="hobby">
                <i className="fa fa-rocket"></i>
                <span>Taekwendo</span>
            </li>
           </ul>
        </div>
    )
}

export default Hobbies;